module.exports = __webpack_public_path__ + "static/NON-a9ece6032bf68c12a4b31c94628f505a.png";